import CheckOut from "./Checkout";
import { Button, Center, Spinner, Text } from "@chakra-ui/react";
import { Elements } from "@stripe/react-stripe-js";
import { StripeElementsOptions } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";
import Link from "next/link";
import { useEffect, useState } from "react";

interface CheckOutWrapperProps {
  price: number | null;
  art: string | null;
  uuid: string | null;
  image: string | null;
  id: number | null;
  issued: string | null;
  ext_file: string | null;
}

const key = process.env.NEXT_PUBLIC_STRIPE_KEY;
const stripePromise = loadStripe(key as string);

const options: StripeElementsOptions = {
  mode: "payment",
  amount: 299,
  currency: "usd",
};

export default function CheckOutWrapper(props: CheckOutWrapperProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if (!stripePromise) {
      setIsLoading(false);
    }
  }, []);

  return (
    <div style={{ marginBottom: 15 }}>
      {!isLoading && (
        <Text fontSize="2xl" mt={3} mb={3} ml={0}>
          $ 2.99
        </Text>
      )}
      {isLoading && (
        <Center mt={5}>
          <Spinner color="rgba(255,153,213,0.9)" speed="0.6s" thickness="3px" />
        </Center>
      )}
      {!stripePromise && (
        <>
          <Center>
            <p>Checkout is not supported on this browser</p>
          </Center>
          <Center mt={5}>
            <Link href="/get-app">
              <Button variant="outline">Get App</Button>
            </Link>
          </Center>
        </>
      )}
      {options && (
        <Elements stripe={stripePromise} options={options}>
          <CheckOut
            price={props.price}
            card_id={props.id}
            ext_file={props.ext_file}
            art={props.art}
            uuid={props.uuid}
            issued={props.issued}
            image={props.image}
            setIsLoading={setIsLoading}
          />
        </Elements>
      )}
    </div>
  );
}
